
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workingolf",
      function () {
        return require("private-next-pages/workingolf/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workingolf"])
      });
    }
  